import { PETestQuestionAnswer } from "../../data/interfaces"

interface IPEAnswerProps { 
    item: PETestQuestionAnswer
    isRight: boolean
    isSelect:boolean
    onChange: (item: PETestQuestionAnswer) => void
}
const Answer = ({item, ...props}:IPEAnswerProps): JSX.Element => {
    const onChange = () => { 
        //console.table({item})
        props.onChange( item )
	}
    return <div className="pe-matching-answer-single " data-answer-id={item.id} data-testid="test-answer">
        <div className="pe-matching-answer-content">
            <label 
                className="_check_ d-flex flex-column " 
                htmlFor={`matchinger_${item.id}`}
            >
                <div className="pe-matching-answer-media">
                    {
                        item.thumbnail
                            && 
                            <img 
                                alt="" 
                                src={item.thumbnail} 
                                className="pe-matching-answer-image" 
                                 data-testid="test-answer-media"
                            /> 
                    }
                </div>
                <div className={`pe-matching-answer-title ${props.isRight ? "right-variant" : ""}`}>
                    {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
                    <input
                        name="matchinger"
                        type="radio"
                        role="radio"
                        className=""
                        checked={ props.isSelect }
                        onClick={ onChange }
                        onChange={ onChange }
                        id={`matchinger_${item.id}`}
                        data-testid="test-answer-input"
                    />
                    <span data-testid="test-answer-title">{item.title}</span> 
                </div>
                {
                    item.post_content
                        &&
                        <div className="pe-matching-answer-descr" data-testid="test-answer-content">
                            {item.post_content}
                        </div> 
                }
            </label>
        </div>
    </div>  
} 

export default Answer